import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-insufficient-privileges',
  imports: [CommonModule],
  templateUrl: './insufficient-privileges.component.html',
  styleUrl: './insufficient-privileges.component.scss',
})
export class InsufficientPrivilegesComponent {}
